<template>
  <div class="c-dashboard__card">
    <b-card :title="$t('lang.label_certificate_by_signature_key_alogrithm')" class="text-center">
      <pie-chart :style="styles" :chart-data="pieChartData" :options="pieChartOptions"></pie-chart>
    </b-card>
  </div>
</template>
<script>
import PieChart from "../PieChart";
export default {
  name: "CertificateGroupedBySignatureAlgorithm",
  components: {
    PieChart
  },
  props: {
    statistics: {}
  },
  data() {
    const _this = this;
    return {
      pieChartOptions: {
        responsive: true,
        onClick: function(evt, array) {
          var position = array[0]._index;
          var label = this.tooltip._data.labels[position];
          _this.goToSearch(label);
        },
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? "pointer" : "default";
        },
        legend: {
          display: true
        },
        maintainAspectRatio: false //should be false to make effect of height and width change
      },
      backgroundColor: ["#88B04B", "#0F4C81", "#FF6F61"],
      //customize height and weight
      styles: {
        width: "100%",
        height: "300px"
      }
    };
  },
  computed: {
    pieChartData() {
      const certSignatureAlgorithm = this.$props.statistics.data.certSignatureAlgorithm;
      const chartData = {};
      //build labels and data in seperate array
      var labels = [];
      var data = [];
      Object.keys(certSignatureAlgorithm).forEach(key => {
        labels.push(key);
        data.push(certSignatureAlgorithm[key]);
      });

      let datasets = {};
      //datasets back ground color
      datasets.backgroundColor = this.backgroundColor;
      //datasets data
      datasets.data = data;

      chartData.datasets = [];
      //labels
      chartData.labels = labels;
      //chart data
      chartData.datasets.push(datasets);
      return chartData;
    }
  },
  methods: {
    goToSearch(value) {
      const searchFilter = {
        certSignatureAlgorithm: [value.replace("With", "_WITH_")]
      };
      this.$store.commit("certificate/addFromGraph_columnsVisible", "certSignatureAlgorithm");
      this.$store.commit("certificate/resetAndUpdate_searchFilter", searchFilter);
      this.$router.push({ name: "certificates", params: { isFromChart: true } });
    }
  }
};
</script>
